module.exports = __webpack_public_path__ + "img/crm01.f32b1ecd.jpg";